import { Node } from "prosemirror-model";
import { Plugin, PluginKey } from "prosemirror-state";

interface BlockIDConfig {
	key: string;
	generateId(node: Node): string;
}

export default class BlockID {
	static pluginKey = new PluginKey("fellow-blockid");
	config: BlockIDConfig;

	constructor(config: BlockIDConfig) {
		this.config = config;
	}

	asPlugin = () => {
		const config = this.config;

		return new Plugin({
			appendTransaction(transactions, oldState, newState) {
				const ids = new Set<string>();
				const tr = newState.tr;
				let modified = false;
				newState.doc.descendants((node, pos) => {
					const id = node.attrs[config.key];
					if (id !== undefined) {
						if (id === null || ids.has(id)) {
							const newId = config.generateId(node);
							tr.setNodeMarkup(pos, undefined, { ...node.attrs, [config.key]: newId });
							ids.add(newId);
							modified = true;
						} else {
							ids.add(id);
						}
					}
					return false;
				});

				if (modified) return tr.setMeta("inputRulesIgnore", true);

				return undefined;
			},
		});
	};
}
